import { Grid, Text } from "@radix-ui/themes";

export default function PendingComponent() {
  return (
    <Grid align="center" justify="center" height="100vh" width="100%">
      <Text align="center">Loading...</Text>
    </Grid>
  );
}
